// A grouping rule as a sentence (Rules -> Grouping, owner 2026-10-22 — D-402).
// One builder, so the tab's row and anything else that names a rule say it the
// same way:
//
//   When a line item from GORDON FOOD SERVICE is "chicken breast 10 lb",
//   group it under Poultry.
//   When a line item from GORDON FOOD SERVICE is relevant, offer the group
//   Poultry.

import { GROUPING_MATCH_KIND } from '@ap/shared'
import type { GroupingRule } from '../api/types'

/** Who a rule is for, as its sentence says it. */
export function groupingRuleVendor(r: Pick<GroupingRule, 'vendor_id' | 'vendor_name'>): string {
  return r.vendor_id === null ? 'any vendor' : r.vendor_name || r.vendor_id
}

/** The rule as a full sentence — the row, and the editor's clauses in order. */
export function groupingRuleSentence(r: GroupingRule): string {
  const who = groupingRuleVendor(r)
  if (r.match_kind === GROUPING_MATCH_KIND.relevant) {
    return `When a line item from ${who} is relevant, offer the group ${r.group_name}.`
  }
  return `When a line item from ${who} is "${r.description ?? ''}", group it under ${r.group_name}.`
}
